import React from 'react';
import { FormikTextInput } from 'src/common/form/formik/text-input';

const ShareContactLastNameInput = (props: { value: string, onChange: (e:React.ChangeEvent<string>) => void, disabled: boolean, mergeField?: string | undefined | null }) => {
  return (
    <div className="flex flex-col space-y-2 pb-6">
      <FormikTextInput
        maxLength={50}
        hideCharacterCount
        id="journey-share-alias-form-contact-last-name"
        name="hubspot_contact_last_name"
        label="Last Name"
        placeholder="Contact Last Name"
        type="text"
        autoComplete="off"
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck="false"
        onChange={props.onChange}
        mergeField={props.mergeField}
        value={props.value}
        disabled={props.disabled}
      />
    </div>
  );
};

export default ShareContactLastNameInput;
